// src/components/Card.js
import React from 'react';
import './Card.css';

// 卡牌类型对应的显示信息
export const CARD_INFO = {
  diamond: { name: '钻石', emoji: '💎', color: '#e3f2fd' },
  gold: { name: '黄金', emoji: '🥇', color: '#fff9c4' },
  silver: { name: '白银', emoji: '🥈', color: '#f5f5f5' },
  cloth: { name: '布匹', emoji: '👔', color: '#f3e5f5' },
  spice: { name: '香料', emoji: '🌶️', color: '#fff3e0' },
  leather: { name: '皮革', emoji: '🎒', color: '#efebe9' },
  camel: { name: '骆驼', emoji: '🐫', color: '#fffde7' }
};

function Card({ card, selected, onClick, disabled, small }) {
  if (!card) return null;

  const info = CARD_INFO[card.type] || { name: '未知', emoji: '❓', color: '#fafafa' };

  return (
    <div
      className={`card ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ${small ? 'card-small' : ''}`}
      onClick={onClick}
      style={{ backgroundColor: info.color }}
    >
      <div className="card-emoji">{info.emoji}</div>
      <div className="card-name">{info.name}</div>
    </div>
  );
}

export default Card;
